import { Accordion, AccordionItem } from "./AccordionItem";
const MatrimonyFAQ = () => {
  return (
    <div className="p-6">
      <div className="w-full mx-auto p-4 rounded shadow">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-green-700">
          ❓ Frequently Asked Questions
        </h2>

        <Accordion>
          <AccordionItem title="How do I register on  Matrimony?">
            Create your profile by providing details like name, date of birth,
            religion, community, and contact info. Complete email OPT 
            verification to activate your profile securely.
          </AccordionItem>

          <AccordionItem title="Is my information safe and private?">
            Yes, your privacy is our priority. Your contact details remain
            hidden unless you choose to share them. We use secure encryption and
            provide profile visibility control for your safety.
          </AccordionItem>

          <AccordionItem title="What benefits do Premium Members get?">
            Premium members can  view contact
            details, appear on top of search results, and use advanced filters
            to find better matches faster.
          </AccordionItem>

          <AccordionItem title="How can I verify my profile?">
            You can verify your profile by submitting a valid ID proof and a
            selfie or via a verification call with our team. Verified profiles
            gain higher trust and visibility.
          </AccordionItem>

          <AccordionItem title="Can I hide my contact details from others?">
            Yes, by default your phone and email are hidden. You have complete
            control over who can see your details, ensuring your privacy.
          </AccordionItem>

          <AccordionItem title="How do I search for a suitable match?">
            Use filters like age, religion, community, education, profession,
            and location to find your match. You also receive smart
            recommendations based on your preferences.
          </AccordionItem>

          <AccordionItem title="What is Assisted Matrimony Service?">
            Assisted Matrimony offers a personal relationship manager to help
            you find suitable matches, arrange meetings, and guide you
            throughout your journey until marriage.
          </AccordionItem>

          <AccordionItem title="Can I deactivate or delete my account?">
            Yes, you can deactivate or permanently delete your profile anytime
            from the account settings or by contacting our support team.
          </AccordionItem>

          {/* <AccordionItem title="How do I report a suspicious profile?">
            You can report suspicious profiles using the "Report Abuse" button
            on the profile page. Our moderation team will investigate and take
            quick action for your safety.
          </AccordionItem> */}

 
        </Accordion>
      </div>
    </div>
  );
};

export default MatrimonyFAQ;
